/**
 * useActiveSessions — GET /realtime-console/sessions TanStack Query v5
 * queryKey: ['realtime-console', 'sessions']
 * REALTIME_CONSOLE_READ 권한 필요
 */
import { useQuery } from '@tanstack/react-query';
import { realtimeConsoleApi } from '../api/realtimeConsoleApi';

export function useActiveSessions(enabled = true) {
  return useQuery({
    queryKey: ['realtime-console', 'sessions'],
    queryFn: () => realtimeConsoleApi.sessions(),
    staleTime: 10_000,
    refetchInterval: enabled ? 15_000 : false,
    enabled,
    retry: 1,
  });
}
